import _extends from 'babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import collapse_white_left from '@/assets/img/collapse_white_left.png';
import collapse_white_right from '@/assets/img/collapse_white_right.png';

export default {
  name: 'Sidebar',
  data: function data() {
    return {
      collapse: false, //菜单开关
      buttonNameCollapse: false,
      bottom_icon_url: require('@/assets/img/collapse_white_left.png')
    };
  },

  watch: {
    collapse: function collapse(val) {
      if (val) {
        this.buttonNameCollapse = val;
        this.bottom_icon_url = collapse_white_left;
      } else {
        this.bottom_icon_url = collapse_white_right;
        this.buttonNameCollapse = val;
      }
    }
  },
  computed: _extends({}, mapGetters(['activeIndex'])),
  props: {
    // mainRouter: {
    //   type: String,
    //   default: ''
    // },
    addOffset: {
      type: Number,
      default: 70
    },
    /** 侧边导航数组 */
    items: {
      type: Array,
      default: []
    },
    backgroundColor: {
      type: String,
      default: '#2D3037'
    },
    activeTextColor: {
      type: String,
      default: '#fff'
    },
    textColor: {
      type: String,
      default: '#bebec0'
    }
  },
  methods: {
    toggleSideBarClick: function toggleSideBarClick() {
      this.collapse = !this.collapse;
      this.$root.eventHub.$emit('collapseBtn', this.collapse);
    },
    menuSelect: function menuSelect(key, keyPath) {
      // select  菜单激活回调  index: 选中菜单项的 index, indexPath: 选中菜单项的 index path

      this.$router.push(key);
    }
  }
};